<template>
  <div class="w-full h-full" id="mapbox"></div>
</template>

<script>
import mapboxgl from "mapbox-gl/dist/mapbox-gl.js";

export default {
  name: "Map",
  data() {
    return {
      isInDarkMode: false,
      token:
        "pk.eyJ1IjoiY2FtdG9zaCIsImEiOiJja2F5NWI4ZDAwYWpwMzJwaWgzNzBka3c3In0.fUjQ2yX0-td-XDfn94hKBw",
      markers: {
        from: null,
        to: null,
        journey: []
      },
      map: null,
      jaude: [3.082242012023926, 45.770057678222656]
    };
  },
  mounted() {
    const darkModePreference = window.matchMedia(
      "(prefers-color-scheme: dark)"
    );
    this.isInDarkMode = darkModePreference.matches;

    const mapBoxConfig = () => ({
      container: "mapbox",
      style: this.isInDarkMode
        ? "mapbox://styles/mapbox/dark-v10"
        : "mapbox://styles/mapbox/streets-v10",
      center: this.jaude,
      zoom: 13
    });

    mapboxgl.accessToken = this.token;
    this.map = new mapboxgl.Map(mapBoxConfig());

    darkModePreference.addEventListener("change", e => {
      this.isInDarkMode = e.matches;
      this.map.remove();
      this.map = new mapboxgl.Map(mapBoxConfig());

      for (let marker of this.markers.journey.concat(
        this.markers.from,
        this.markers.to
      )) {
        marker.addTo(this.map);
      }
    });

    this.map.on("load", () => {
      this.map.resize();
    });

    // Update map when itineraire change
    this.$store.watch(state => state.itineraire, this.itineraireAsChange, {
      deep: true
    });

    // TODO: add T2C border limit
    // const bounds = [
    //   [2.741496, 46.288875], // Commentry
    //   [3.739308, 45.549532] // Ambert
    // ];
    // this.map.setMaxBounds(bounds);
    // this.canvas = this.map.getCanvasContainer();
  },
  methods: {
    itineraireAsChange() {
      this.clearMarker("from");
      this.clearMarker("to");
      this.clearMarker("journey");

      if (!this.$store.state.journeySelected) {
        const { from, to } = this.$store.state.itineraire.selected;

        if (!from && !to) {
          return null;
        }

        if (from !== null) {
          this.addMarker(
            from.center,
            "from",
            this.isInDarkMode ? "#1b93cf" : "#3482F6"
          );

          this.map.setCenter(from.center);
        }
        if (to !== null) {
          this.addMarker(
            to.center,
            "to",
            this.isInDarkMode ? "#ebd410" : "#FBBF24"
          );
        }

        return;
      }

      const selectedJourney = this.$store.state.itineraire.selectedJourney;
      selectedJourney.journey
        .filter(({ departure }) => departure.longitude && departure.longitude)
        .map(({ metadata, departure, arrival }) => {
          this.addJourneyMarker(
            [departure.longitude, departure.latitude],
            metadata.lineColor
          );

          this.addJourneyMarker(
            [arrival.longitude, arrival.latitude],
            metadata.lineColor
          );
        });
    },
    clearMarker(direction) {
      if (direction == "journey") {
        this.markers.journey.map(marker => marker.remove());
        return;
      }

      const marker = this.markers[direction];
      if (marker) {
        marker.remove();
      }
    },
    addJourneyMarker(latLong, color) {
      const marker = new mapboxgl.Marker({
        draggable: false,
        color
      });

      console.log("addJourneyMarker", { latLong, color, marker });
      marker.setLngLat(latLong).addTo(this.map);
      this.markers.journey.push(marker);
    },
    addMarker(latLong, direction, color) {
      this.clearMarker(direction);

      const marker = new mapboxgl.Marker({
        draggable: false,
        color
      });
      console.log("addMarker", { latLong, color, direction, marker });
      marker.setLngLat(latLong).addTo(this.map);
      this.markers[direction] = marker;
    }
  }
};
</script>
